import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import * as services from "../services/services";
import loginIllustration from "../images/dog.jpg";
import logo from "../images/itaam-company-2.png";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const isFromMobile =
    new URLSearchParams(location.search).get("from") === "mobile";
  const loginPath = isFromMobile ? "/mobile/login" : "/auth/login";

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      toast.error("กรุณากรอกอีเมล");
      return;
    }

    if (!emailRegex.test(email)) {
      toast.error("รูปแบบอีเมลไม่ถูกต้อง");
      return;
    }

    try {
      setIsSubmitting(true);
      const res = await services.forgotPassword({ email });

      if (res?.data?.data?.code === "USER_NOT_FOUND") {
        toast.error("ไม่พบ Email ในระบบ");
        return;
      }

      toast.success("ส่งลิงก์รีเซ็ตแล้ว");
    } catch (err) {
      const status = err?.response?.status;

      if (status === 404) {
        toast.error("ไม่พบ Email นี้ในระบบ");
      } else if (status === 500) {
        toast.error("เซิร์ฟเวอร์ขัดข้อง กรุณาลองใหม่ภายหลัง");
      } else {
        toast.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#f6f7fb] flex justify-center lg:block">
      <Toaster />

      <div
        className="hidden lg:flex fixed inset-y-0 left-0 w-[40%] bg-cover bg-center"
        style={{ backgroundImage: `url(${loginIllustration})` }}
      />

      <div className="flex min-h-screen w-full max-w-[480px] items-center justify-center bg-white px-5 py-8 lg:ml-[40%] lg:w-[60%] lg:max-w-none lg:px-8">
        <form onSubmit={handleSubmit} className="w-full max-w-md">
          <div className="flex justify-center mb-8">
            <img src={logo} alt="Bow HIS" className="w-36 lg:w-32" />
          </div>

          <h1 className="text-2xl font-bold text-[#172033] text-center mb-2">
            ลืมรหัสผ่าน
          </h1>

          <p className="text-sm leading-6 text-gray-600 text-center mb-6">
            กรอกอีเมลที่ใช้ลงทะเบียน ระบบจะส่งลิงก์สำหรับตั้งรหัสผ่านใหม่ไปให้
          </p>

          <div className="mb-5">
            <label className="text-sm font-semibold text-gray-700">Email</label>
            <input
              type="email"
              inputMode="email"
              autoComplete="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 focus:outline-none"
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-[#e85f24] hover:bg-[#d8521d] disabled:bg-gray-300 text-white font-bold py-3 rounded-lg transition"
          >
            {isSubmitting ? "กำลังส่งลิงก์..." : "ส่งลิงก์รีเซ็ตรหัสผ่าน"}
          </button>

          <p className="text-center text-sm text-gray-500 mt-6">
            <Link
              to={loginPath}
              className="font-semibold text-[#e85f24] hover:underline"
            >
              กลับสู่หน้าเข้าสู่ระบบ
            </Link>
          </p>
        </form>
      </div>
    </main>
  );
}
